import { API } from "aws-amplify";

const insert = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  await API.post("InasakuAPI", "/inasaku/accesslogs", myInit);
};

export default {
  insert: insert,
};
